import { S } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { ConfigService } from 'projects/apna-lib/src/lib/services/config.service';
import { F1GtmService } from 'projects/apna-lib/src/lib/services/f1-gtm.service';

export const visaFeedbackOptions = {
  FEEDBACK: 'Feedback',
  SUPPORT: 'Support',
  COMPLAINT: 'Complaint',
  OTHER: 'Other',
};
@Component({
  selector: 'fa-help-component',
  templateUrl: './help-component.component.html',
  styleUrls: ['./help-component.component.scss'],
})
export class HelpComponentComponent implements OnInit {
  partnerDetails:any;
  studentDetails:any;
  puid: any;
  dataModel: any = 'visa-feedbacks';
  layout: FormlyFieldConfig[];
  model: any = {};
  // userId: any = JSON.parse(localStorage.getItem('userId') || '');
  options: any;
  constructor(
    private modalService: NgbModal,
    private configService: ConfigService,
    private apiHelperService: ApiHelperService,
    private visaService: F1GtmService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    const puid = this.activatedRoute?.snapshot?.params.puid;
    this.puid = puid;

    this.loadPermissions();

    this.getUserDetails();
    this.getPartnerDetails(this.puid);

  }

  private async loadPermissions(): Promise<void> {
    try {
      this.configService.getKeyConfiguration('mockVisaFeedbackOptions').then((res: any) => {
        this.options = res;
        this.setLayout();
        setTimeout(() => {
          this.model = undefined;
          this.model = {};
        }, 100);
      })

    } catch (error) {
      console.error('Error loading permissions:', error);

    }
  }

  getUserDetails() {
    let interviewCode = localStorage.getItem('visaCode');
    const apiEndpoint = `partner-licences/by-licence-number/${interviewCode}`;
    this.apiHelperService.getData(apiEndpoint).then((data: any) => {
      if (data) {
        const filter = {
          where: {
            _id: data?.studentId
          }
        };
        this.apiHelperService.getData('user', filter).then((res:any)=>{

          this.studentDetails = res?.users[0];
        })
      }

    })
  }

  getPartnerDetails(partnerUid) {
    this.apiHelperService.getDataById("user/by-uid", partnerUid).subscribe((response: any) => {
      let partnerDetails = { ...response?.user };
      this.partnerDetails = partnerDetails;
    })
  }

  setLayout() {
    this.layout = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            key: 'category',
            type: 'select',
            className: 'col-12',
            templateOptions: {
              label: 'Please select a category',
              required: true,
              options: [
                { label: 'Please select' },
                { value: visaFeedbackOptions?.SUPPORT, label: 'Support' },
                { value: visaFeedbackOptions?.FEEDBACK, label: 'Feedback' },
                { value: visaFeedbackOptions?.COMPLAINT, label: 'Complaint' },
                { value: visaFeedbackOptions?.OTHER, label: 'Other' },
              ],
            },
          },
          {
            key: 'comment',
            type: 'textarea',
            className: 'col-12',
            templateOptions: {
              label: 'Please describe your issue or request',
              placeholder:
                'Please provide detailed information about your request...',
            },
            hideExpression: (model) => model.category === 'Feedback',
            expressionProperties: {
              'templateOptions.required': (model: any) => {
                return model.category !== 'Feedback';
              },
            },
          },
          {
            fieldGroupClassName: 'row ',
            hideExpression: (model) => model.category !== 'Feedback',
            fieldGroup: [
              {
                className: 'col-12 col-md-12',
                key: 'experience',
                type: 'feedback-emoji',
                templateOptions: {
                  label: 'How was your experience?',
                  required: true,
                  options: this.options,
                  onClick: (model: any) => {
                    this.model.experience = String(model.value);
                    setTimeout(() => {
                      let newModel = { ...this.model };
                      this.model = undefined;
                      this.model = newModel;
                    }, 100);
                  },
                },
              },
              {
                className: 'col-12 col-md-12',
                key: 'questionCoveredTopic',
                type: 'feedback-emoji',
                templateOptions: {
                  label: 'Did the questions cover all VISA interview topics?',
                  required: true,
                  options: this.options,
                  onClick: (model: any) => {
                    this.model.questionCoveredTopic = String(model.value);
                    setTimeout(() => {
                      let newModel = { ...this.model };
                      this.model = undefined;
                      this.model = newModel;
                    }, 100);
                  },
                },
              },
              {
                className: 'col-12 col-md-12',
                key: 'preparationLevel',
                type: 'feedback-emoji',
                templateOptions: {
                  label: 'How confident are you for the actual VISA interview?',
                  required: true,
                  options: this.options,
                  onClick: (model: any) => {
                    this.model.preparationLevel = String(model.value);
                    setTimeout(() => {
                      let newModel = { ...this.model };
                      this.model = undefined;
                      this.model = newModel;
                    }, 100);
                  },
                },
              },
              {
                className: 'col-7',
                key: 'processLevel',
                type: 'textarea',
                templateOptions: {
                  label:
                    'Which part of the process was confusing or needed more support?',
                  placeholder:
                    'Please specify the areas or steps that were unclear or where you needed additional guidance...',
                  required: true,
                },
              },
              {
                className: 'col-5',
                key: 'featureLevel',
                type: 'textarea',
                templateOptions: {
                  label: "What were you expecting but didn't find?",
                  placeholder:
                    'Please describe features or information you were looking for...',
                  required: true,
                },
              },
              {
                className: 'col-12',
                key: 'openFeedback',
                type: 'textarea',
                templateOptions: {
                  label: 'Any other feedback',
                  placeholder:
                    'Share any additional thoughts, suggestions, or concerns...',
                  required: false,
                },
              },
            ],
          },
          {
            type: 'button',
            className: 'col-12 ',
            templateOptions: {
              className: 'd-grid ',
              btnType: 'primary py-3 rounded rounded-1 text-light mb-2',
              type: 'submit',
              text: 'Submit',
            },
          },
        ],
      },
    ];
  }

  openHelp(content) {
    this.modalService.open(content, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
  }

  onSubmitResponse(ev: any) {
    if (ev.data) {
    }
  }

  dataProcessor(data: any) {
    const finalData = {
      ...data,
      id: localStorage.getItem('userId'),
      studentId: this.studentDetails?._id,
      studentName: this.studentDetails?.name,
      partnerId: this.partnerDetails?._id,
      partnerUid: this.partnerDetails?.uid,
      partnerEmail: this.partnerDetails?.email,
    };
    this.apiHelperService
      .postData(this.dataModel, finalData)
      .subscribe((res: any) => {
        this.modalService.dismissAll();
        this.model = {};
        this.setLayout();
        switch (data?.category) {
          case visaFeedbackOptions?.SUPPORT:
            return this.apiHelperService.openSnackBar(
              'Support Ticket Raised successfully'
            );
          case visaFeedbackOptions?.FEEDBACK:
            return this.apiHelperService.openSnackBar(
              'Feedback Submitted successfully'
            );
          case visaFeedbackOptions?.COMPLAINT:
            return this.apiHelperService.openSnackBar(
              'Complaint Raised successfully'
            );
          case visaFeedbackOptions?.OTHER:
            return this.apiHelperService.openSnackBar(
              'Request submitted successfully'
            );
        }
      });
  }
}
